// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.9.1_webpack@5.90.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YmpbIoigmEVtamUTH02A{display:inline-block;border-radius:18px;font-weight:bold;line-height:16px;margin:0 4px}.YmpbIoigmEVtamUTH02A.Jls9uJ6YlNLMR6Ufny2p{font-size:10px;padding:4px 6px}.YmpbIoigmEVtamUTH02A._BsKtxW8FRAqyv6uaBLv{font-size:12px;padding:6px 12px}.YmpbIoigmEVtamUTH02A.tyDko8Q3U9nVv3QLQTy0{font-size:16px;padding:8px 16px}.YmpbIoigmEVtamUTH02A.M2IPEujMF9Kw4OFiM7Pe{background:#f8f8f8;color:#131a4f}.YmpbIoigmEVtamUTH02A.adPh7of4tBUIb3_NzAvb{background:#6e32f0;color:#fff}.YmpbIoigmEVtamUTH02A.sHLLvkNC1ADWjCKIQins{background:#eef4fc;color:#8292b1}.YmpbIoigmEVtamUTH02A.Ziq3_6DFARH1ctQJIUYR{background:#dff5fe;color:#0a82c6}.YmpbIoigmEVtamUTH02A.yzRUVkUmsUsMIddn8QwD{background:#fff5d1;color:#d96800}.YmpbIoigmEVtamUTH02A.xWUbJwNvEPmXHoi3Km1V{background:#1ec8fa;color:#fff}.YmpbIoigmEVtamUTH02A.YbuE2jJe7KGYVGwRaoBw{background:#ffe7e7;color:#cd0101}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-dark": `#e73b05`,
	"primary": `adPh7of4tBUIb3_NzAvb`,
	"primary-light": `#ffe4df`,
	"primary-extra-light": `#fff2f0`,
	"secondary-dark": `#8292b1`,
	"secondary": `sHLLvkNC1ADWjCKIQins`,
	"secondary-light": `#d0dae9`,
	"secondary-extra-light": `#eef4fc`,
	"default-dark": `#898ca7`,
	"default": `M2IPEujMF9Kw4OFiM7Pe`,
	"default-light": `#ecedf5`,
	"default-extra-light": `#f8f8f8`,
	"warning-dark": `#d96800`,
	"warning": `yzRUVkUmsUsMIddn8QwD`,
	"warning-light": `#ffeba3`,
	"warning-extra-light": `#fff5d1`,
	"info-dark": `#0a82c6`,
	"info": `Ziq3_6DFARH1ctQJIUYR`,
	"info-light": `#beebfc`,
	"info-extra-light": `#dff5fe`,
	"success-dark": `#069941`,
	"success": `xWUbJwNvEPmXHoi3Km1V`,
	"success-light": `#c6f1c3`,
	"success-extra-light": `#e3f9e1`,
	"danger-dark": `#cd0101`,
	"danger": `YbuE2jJe7KGYVGwRaoBw`,
	"danger-light": `#ffcece`,
	"danger-extra-light": `#ffe7e7`,
	"text-primary": `#131a4f`,
	"text-secondary": `#8292b1`,
	"shadow-25": `rgba(184,186,202,.25)`,
	"shadow-50": `rgba(184,186,202,.5)`,
	"pill": `YmpbIoigmEVtamUTH02A`,
	"small": `Jls9uJ6YlNLMR6Ufny2p`,
	"standard": `_BsKtxW8FRAqyv6uaBLv`,
	"large": `tyDko8Q3U9nVv3QLQTy0`
};
export default ___CSS_LOADER_EXPORT___;
